/*
 * getMapPoints module is in charge of returning a fromFetch observable to the calling control.
 * This observable represents a promise build around fetch javascript API. The result
 * of this promise holds an array of markers to paint in the map, so by returning the control
 * to the calling module, we will achieve to see those retrieved markers on screen as a
 * result of the observable promise returned.
 */

import { fromFetch } from 'rxjs/fetch';
import { mapGetCommunitiesPoints, mapGetHomesPoints } from 'constants/routes';

export const getCommunityMapPoints$ = function (payload) {
  const requestObject = {
    method: 'POST',
    body: JSON.stringify({
      searchCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    selector: (response) => response.json(),
  };

  return fromFetch(mapGetCommunitiesPoints, requestObject);
};

export const getHomeMapPoints$ = function (payload) {
  const requestObject = {
    method: 'POST',
    body: JSON.stringify({
      searchCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    selector: (response) => response.json(),
  };

  return fromFetch(mapGetHomesPoints, requestObject);
};
